import { createSlice } from "@reduxjs/toolkit";

const enhancedConditionsDocumentsListSlice = createSlice({
	name: "enhancedConditionsDocumentsList",
	initialState: {
		data: [],
	},
	reducers: {
		setEnhancedConditionsDocumentsList: (state, action) => {
			state.data = action.payload;
		},
	},
});

export const { setEnhancedConditionsDocumentsList } =
	enhancedConditionsDocumentsListSlice.actions;
export default enhancedConditionsDocumentsListSlice.reducer;

export const selectEnhancedConditionsDocumentsList = (state) =>
	state.enhancedConditionsDocumentsList?.data;
